import { render } from "./ProcedureResults.vue?vue&type=template&id=468d59a2"
import script from "./ProcedureResults.vue?vue&type=script&lang=js"
export * from "./ProcedureResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__